import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, Input, List, Row, Alert } from 'antd'
import React from 'react'
import { Toaster } from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { DOMINIO_SERVIDOR } from '../../api/url'
import { alias_examen } from '../../data/datos'
import useEditarPregunta from '../../hooks/adminexamen/useEditarPregunta'

const EditarPregunta = () => {

    // const { id:pk_materia } = useParams('id')
    const {id:pk_materia, id_pregunta:arr_pregunta} = useParams()

    let pks = arr_pregunta?.split("-");
    const indice = pks[1]

    const navigate = useNavigate()
    const { guardar, form, onChange, borrarImagen, respuestas, actualizarContenidoRespuesta, cambiarRespuestaCorrecta } = useEditarPregunta()

    return (
      <>
        <Button
          type="primary"
          shape="round"
          icon={<ArrowLeftOutlined />}
          size="middle"
          onClick={() => navigate(-1)}
          style={{
            marginBottom: "20px",
          }}
        >
          Preguntas
        </Button>

        <Card className="sombra">
          <Form
            name="basic"
            form={form}
            layout="vertical"
            autoComplete="off"
            onFinish={guardar}
          >
            <Form.Item
              label="Pregunta"
              name="pregunta"
              rules={[
                {
                  required: true,
                  message: "Campo requerido",
                },
              ]}
            >
              <Input.TextArea rows={3} />
            </Form.Item>

            <Col span={24}>
              <label>Imagen (opcional)</label>
              <input
                id="inputFileEdit"
                type="file"
                onChange={onChange}
                accept="image/*"
              />
              <div style={{ display: "flex" }}>
                <img
                  id="imgPruebaEdit"
                  style={{
                    maxHeight: 200,
                  }}
                  alt='Imagen de pregunta'
                />
                <Button
                  onClick={borrarImagen}
                  style={{
                    marginTop: 20,
                  }}
                  type="dashed"
                >
                  Borrar imagen
                </Button>
              </div>
            </Col>

            {/* <img src={ urlImagen }/> */}

            <Form.Item
              wrapperCol={{
                offset: 8,
              }}
            >
              <Button type="primary" htmlType="submit">
                Guardar
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <Card className="sombra" style={{ marginTop: 40 }}>
          <List
            header={
              <div>
                <div>Respuestas</div>
                <div>
                  <Alert message="Haga click sobre el texto de una respuesta para editar su contenido" type="info" showIcon />
                </div>
              </div>
            }
            bordered
            dataSource={respuestas}
            renderItem={(e) => {

              let carpeta = alias_examen[ pk_materia ]
              let nombre = `${indice}-${carpeta}-${e.letra}.png`

              let src = `${DOMINIO_SERVIDOR}/img/examen/${carpeta}/${nombre}`
              // let src = `http://10.5.1.19:8000/img/examen/MC/4-MC-A.png`

              // eslint-disable-next-line
              if ( e.respuesta === ':imagen' && e.correcta == 1 ) {
                return (
                  <List.Item>
                    <Row gutter={[10]} style={{ width: "100%" }}>
                      <Col span={6}>
                        <Button type="primary" disabled>
                          Cambiar como respuesta correcta
                        </Button>
                      </Col>
                      <Col
                        span={18}
                        className="cursor-pointer"
                        onClick={() =>
                          actualizarContenidoRespuesta(
                            e.respuesta,
                            e.pk_respuestas
                          )
                        }
                      >
                        { e.letra } <img src={ src } alt='Imagen de respuesta'/>
                      </Col>
                    </Row>
                  </List.Item>
                )
                // eslint-disable-next-line
              } else if ( e.respuesta === ':imagen' && e.correcta == 0 ) {
                return (
                  <List.Item>
                    <Row gutter={[10]} style={{ width: "100%" }}>
                      <Col
                        span={6}
                        onClick={() =>
                          cambiarRespuestaCorrecta(
                            e.pk_respuestas,
                            e.fk_pregunta
                          )
                        }
                      >
                        <Button type="primary">
                          Cambiar como respuesta correcta
                        </Button>
                      </Col>
                      <Col
                        span={18}
                        className="cursor-pointer"
                        onClick={() =>
                          actualizarContenidoRespuesta(
                            e.respuesta,
                            e.pk_respuestas
                          )
                        }
                      >
                        { e.letra } <img src={ src } alt='Imagen de respuesta'/>
                      </Col>
                    </Row>
                  </List.Item>
                )
                // eslint-disable-next-line
              } else if (e.correcta == 1) {
                return (
                  <List.Item>
                    <Row gutter={[10]} style={{ width: "100%" }}>
                      <Col span={6}>
                        <Button type="primary" disabled>
                          Cambiar como respuesta correcta
                        </Button>
                      </Col>
                      <Col
                        span={18}
                        className="cursor-pointer"
                        onClick={() =>
                          actualizarContenidoRespuesta(
                            e.respuesta,
                            e.pk_respuestas
                          )
                        }
                      >
                        <p>
                          { e.letra } .- { e.respuesta }
                        </p>
                      </Col>
                    </Row>
                  </List.Item>
                );
              } else {
                return (
                  <List.Item>
                    <Row gutter={[10]} style={{ width: "100%" }}>
                      <Col
                        span={6}
                        onClick={() =>
                          cambiarRespuestaCorrecta(
                            e.pk_respuestas,
                            e.fk_pregunta
                          )
                        }
                      >
                        <Button type="primary">
                          Cambiar como respuesta correcta
                        </Button>
                      </Col>
                      <Col
                        span={18}
                        className="cursor-pointer"
                        onClick={() =>
                          actualizarContenidoRespuesta(
                            e.respuesta,
                            e.pk_respuestas
                          )
                        }
                      >
                        <p>
                          {e.letra}.- {e.respuesta}
                        </p>
                      </Col>
                    </Row>
                  </List.Item>
                );
              }
            }}
          />
        </Card>
        <Toaster />
      </>
    );
}

export default EditarPregunta
